import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.subject.item');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-subject-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.subject.item/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
}`],
})
export class PageSubjectItemComponent implements OnInit, OnDestroy {
    public WizRoute: any = WizRoute;
    constructor(@Inject( Service) public service: Service,@Inject( Router)  public router: Router) { }

    public subjectId: string = '';
    public subject: any = null;
    public tree: any[] = [];
    public totalQuestions: number = 0;
    public loading: boolean = true;
    public expandedChapters: any = {};
    public selectedChapter: any = null;
    public selectedTopic: any = null;
    public previewQuestions: any[] = [];
    public previewLoading: boolean = false;
    private routerSub: any = null;

    public subjectNames: any = {
        korean: '한국사',
        world: '세계사',
        eastasia: '동아시아사',
        middle: '중등 역사',
        qualify: '한능검',
        qualify_past: '한능검 기출'
    };

    public subjectColors: any = {
        korean: { bg: 'bg-blue-50', border: 'border-blue-200', text: 'text-blue-700', accent: 'bg-blue-600' },
        world: { bg: 'bg-green-50', border: 'border-green-200', text: 'text-green-700', accent: 'bg-green-600' },
        eastasia: { bg: 'bg-orange-50', border: 'border-orange-200', text: 'text-orange-700', accent: 'bg-orange-600' },
        middle: { bg: 'bg-purple-50', border: 'border-purple-200', text: 'text-purple-700', accent: 'bg-purple-600' },
        qualify: { bg: 'bg-red-50', border: 'border-red-200', text: 'text-red-700', accent: 'bg-red-600' },
        qualify_past: { bg: 'bg-teal-50', border: 'border-teal-200', text: 'text-teal-700', accent: 'bg-teal-600' }
    };

    public gradeLevelLabels: any = {
        middle2: '중2', middle3: '중3', high: '고등', suneung: '수능'
    };

    public async ngOnInit() {
        await this.service.init();
        this.subjectId = WizRoute.segment.id || '';
        if (this.subjectId) await this.load();
        await this.service.render();

        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                const newId = WizRoute.segment.id || '';
                if (newId && newId !== this.subjectId) {
                    this.subjectId = newId;
                    this.expandedChapters = {};
                    this.selectedChapter = null;
                    this.selectedTopic = null;
                    this.previewQuestions = [];
                    await this.load();
                }
            }
        });
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        let res = await wiz.call("info", { subject_id: this.subjectId });
        if (res.code === 200) {
            this.subject = res.data.subject;
            this.tree = res.data.tree || [];
            this.totalQuestions = res.data.total_questions || 0;
        }
        this.loading = false;
        await this.service.render();
    }

    public toggleChapter(chId: string) {
        this.expandedChapters[chId] = !this.expandedChapters[chId];
        this.service.render();
    }

    public async selectChapter(ch: any) {
        this.selectedChapter = ch;
        this.selectedTopic = null;
        this.previewLoading = true;
        await this.service.render();
        let res = await wiz.call("questions", { chapter_id: ch.id });
        if (res.code === 200) this.previewQuestions = res.data.rows || [];
        this.previewLoading = false;
        await this.service.render();
    }

    public async selectTopic(tp: any) {
        this.selectedTopic = tp;
        this.previewLoading = true;
        await this.service.render();
        let res = await wiz.call("questions", { topic_id: tp.id });
        if (res.code === 200) this.previewQuestions = res.data.rows || [];
        this.previewLoading = false;
        await this.service.render();
    }

    public startQuiz(chapterId?: string) {
        let url = '/quiz/setting?subject=' + this.subjectId;
        if (chapterId) url += '&chapter=' + chapterId;
        this.service.href(url);
    }

    public get color() {
        return this.subjectColors[this.subjectId] || this.subjectColors.korean;
    }

    public typeLabel(v: string): string {
        const map: any = { multiple_choice: '5지선다', ox: 'OX', ordering: '순서', matching: '연결', short_answer: '단답' };
        return map[v] || v;
    }

    public isImageContent(content: string): boolean {
        return content?.startsWith('[IMG]') || false;
    }
}

export default PageSubjectItemComponent;